import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class User extends SmartModel {
	constructor(data) {
		super();

		this.birthDate = "0000-00-00 00:00:00";
		this.clientsFolderGuid = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.department = "";
		this.documentsFolderGuid = "";
		this.email = "";
		this.guid = "";
		this.lastActivityAt = "0000-00-00 00:00:00";
		this.lastLoginAt = "0000-00-00 00:00:00";
		this.location = "";
		this.firstName = "";
		this.password = "";
		this.lastName = "";
		this.location = "";
		this.notes = "";
		this.office = "";
		this.password = "";
		this.phone = "";
		this.pictureURL = "";
		this.preferences = {
			areaManagerGuid: "",
			genderForSalutation: "",
			phoneExtension: "",
			zones: ""
		};
		this.permissions = [];
		this.products = [];
		this.roles = [];
		this.status = 8;
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";

		this.__birthDate = "0000-00-00";
		this.__createdAt = "0000-00-00 00:00:00";
		this.__fullName = "";
		this.__passwordConfirm = "";
		this.__permissions = {};
		this.__preserveLogin = true;
		this.__roles = "";
		this.__showAgentFields = false;
		this.__showInternalStaffFields = false;
		this.__showSellRepresentativeFields = false;
		this.__updatedAt = "0000-00-00 00:00:00";

		if (data) {
			this.import(data);
		}
	}

	export(options) {
		var exportData = {};

		if (typeof options === "string") {
			switch (options) {
				case "guid":
					exportData.guid = this.guid;
					break;
				case "logIn":
					exportData.email = this.email;
					exportData.password = this.password;
					break;
				case "register":
					exportData.email = this.email;
					exportData.name = this.firstName;
					exportData.password = this.password;
					exportData.surname = this.lastName;
					break;
			}
		}
		else {
			exportData = this.__export();
			exportData.permissions = JSON.stringify(this.permissions);
			exportData.preferences = JSON.stringify(this.preferences);
			exportData.products = JSON.stringify(this.products);
			exportData.roles = JSON.stringify(this.roles);
			exportData.birthDate = moment.utc(this.birthDate).format("YYYY-MM-DD HH:mm:ss");
			exportData.createdAt = moment.utc(this.createdAt).format("YYYY-MM-DD HH:mm:ss");
			exportData.updatedAt = moment.utc(this.updatedAt).format("YYYY-MM-DD HH:mm:ss");

			if (this.password === "unchanged") {
				delete exportData.password;
			}
		}

		return exportData;
	}

	getGenderLastLetter () {
		if (this.preferences.genderForSalutation === "f") {
			return "a";
		}
		else {
			return "o";
		}
	}

	hasPermission (permissions) {
		if (Array.isArray(permissions)) {
			let found = false;

			for (let i = 0; i < permissions.length; i++) {
				found = this.permissions.indexOf(permissions[i]) > -1;
				if (found) {
					break;
				}
			}

			return found;
		}
		else {
			return this.permissions.indexOf(permissions) > -1;
		}
	}

	hasRole (roles) {
		if (Array.isArray(roles)) {
			let found = false;

			for (let i = 0; i < roles.length; i++) {
				found = this.roles.includes(roles[i]);
				if (found) {
					break;
				}
			}

			return found;
		}
		else {
			return this.roles.indexOf(roles) > -1;
		}
	}

	import (data, options) {
		if (data.permissions && data.permissions !== "" && typeof data.permissions === "string") {
			data.permissions = Utils.parseJSON(data.permissions, "array");

			data.permissions.forEach((item) => {
				this.__permissions[`${item}`] = true;
			}, this);
		}
		else {
			data.permissions = [];
		}

		if (data.products && data.products !== "" && typeof data.products === "string") {
			data.products = Utils.parseJSON(data.products, "array");
		}
		else {
			data.products = [];
		}

		if (data.roles && data.roles !== "" && typeof data.roles === "string") {
			data.roles = Utils.parseJSON(data.roles, "array");
		}
		else {
			data.roles = [];
		}

		// this.__parse(data, options);
		this.__import(data, options);

		if (this.importDateField("birthDate", data.birthDate)) {
			this.__birthDate = this.birthDate.format("YYYY-MM-DD");
			this.__birthDateLabel = this.birthDate.format("DD/MM/YYYY");
		}
		this.importDateField("createdAt", data.createdAt);
		this.importNumberField("status", data.status);
		this.importDateField("updatedAt", data.updatedAt);

		if (data.preferences && data.preferences !== "[]" && data.preferences !== "" && typeof data.preferences === "string") {
			this.preferences = Utils.parseJSON(data.preferences, "object");
		}
		else {
			this.preferences = {
				areaManagerGuid: "",
				genderForSalutation: "",
				phoneExtension: "",
				zones: ""
			};
		}

		this.__fullName = `${this.firstName} ${this.lastName}`;

		this.__showAgentFields = this.roles.indexOf("sellRepresentative") > -1 || this.roles.indexOf("areaManager") > -1 || this.roles.indexOf("projectManager") > -1;
		this.__showSellRepresentativeFields = this.roles.indexOf("sellRepresentative") > -1;
		this.__showInternalStaffFields = this.roles.indexOf("internalStaff") > -1;

		this.password = "unchanged";
		this.__passwordConfirm = "unchanged";
		this.__hasThumbnailURL = this.pictureURL !== "";


		this.__isSystemAdmin = this.hasRole("systemAdmin");
	}

	onDataChanged(data) {
		switch (data.property) {
			case "permissions":
				this.__permissions = {};
				this.permissions.forEach((item) => {
					this.__permissions[`${item}`] = true;
				}, this);

			case "roles":
				this.__showAgentFields = this.roles.indexOf("sellRepresentative") > -1 || this.roles.indexOf("areaManager") > -1 || this.roles.indexOf("projectManager") > -1;
				this.__showSellRepresentativeFields = this.roles.indexOf("sellRepresentative") > -1;
				this.__showInternalStaffFields = this.roles.indexOf("internalStaff") > -1;
				Shark.render();
				break;
			case "__birthDate":
				// 	case "__createdAt":
				// 	case "__updatedAt":
				this[data.property.substr(2)] = moment(data.newValue);
				break;
			case "pictureURL":
				this.__hasThumbnailURL = this.pictureURL !== "";
				break;
		}
	}

	validate () {
		const errors = [];
		this.__errors = {};

		if (this.email === "") {
			errors.push("L'indirizzo eMail è obbligatorio");
			this.__errors.email = true;
			this.__errorsCount++;
		}
		if (this.firstName === "") {
			errors.push("Il nome è obbligatorio");
			this.__errors.firstName = true;
			this.__errorsCount++;
		}
		if (this.lastName === "") {
			errors.push("Il cognome è obbligatorio");
			this.__errors.lastName = true;
			this.__errorsCount++;
		}
		if (this.password === "") {
			errors.push("La password è obbligatoria");
			this.__errors.password = true;
			this.__errorsCount++;
		}
		if (this.password !== "" && this.password !== this.__passwordConfirm) {
			errors.push("La password non corrisponde con quella di verifica");
			this.__errors.__passwordConfirm = true;
			this.__errorsCount++;
		}
		if (this.preferences.genderForSalutation === "") {
			errors.push("Per favore indica il genere da usare per rivolgersi all'Utente");
			this.__errors["preferences.genderForSalutation"] = true;
			this.__errorsCount++;
		}
		if (this.roles.length === 0) {
			errors.push("Devi assegnare almeno un Ruolo all'Utente");
			this.__errors.roles = true;
			this.__errorsCount++;
		}

		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("User", User);

export default User;